// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","newAllocatorAnonymous":"_1xR9VYBursayE6R27-weG4","pieChartIcon":"_1mriQaee_dPQic4QvVrtZR"};